import type { RuleNames } from "./feature-names";

/** European Portuguese names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesPt: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Aprovação do proprietário acima de",
    ID_IMAGE_RETENTION_RULE: "Conservação das imagens de identidade",
    FIRST_REPLY_TARGET_RULE: "Prazo da primeira resposta",
    INTERIM_SUSPENSION_REVIEW_RULE: "Revisão de uma suspensão provisória",
    UNANSWERED_JOB_EXPIRY_RULE: "Expiração de um pedido sem resposta",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Prazo de tolerância de uma assinatura",
    STAFF_SESSION_INACTIVITY_RULE: "Fim de sessão após inatividade",
  },
  categories: {
    payments: "Pagamentos",
    support: "Processos",
    safety: "Confiança e segurança",
    onboarding: "Verificação",
    jobs: "Pedidos",
    access: "Acesso",
  },
};
